module.exports = __webpack_public_path__ + "static/media/fox_and_iphone.7613eb7b.mp3";